import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { NavParams } from 'ionic-angular'
import { Activity } from 'api/models';
import { ISDEV, APP_TITLE } from '../../services/config';
import { App } from "ionic-angular";

export type FilterSections = Array<{
  label: string,
  type: string,
  multiselect?: boolean,
  isExpanded?: boolean,
  options: Array<{
    value: string,
    label: string,
    selected?: boolean,
  }>,
}>;

/*
 * Sample usage

 <filter-menu [(filterSections)]="filterSections" (onDone)="didChangeThing($event)" (onCancel)="didCancelThing()"></filter-menu>

 NOTE: the menu items are two way bound, so it's up to the controlling component to properly handle canceling / managing
 the "untouched" state when the component is shown

 onDone is passed the filterSections

  filterSections = [
    {
      label: 'Activity Status',
      multiselect: false,
      isExpanded: true,
      options: [
        { label: 'Not Started', selected: true },
        { label: 'In Progress' },
        { label: 'Completed' },
      ]
    },
    {
      label: 'Data Lookahead',
      options: [
        { label: '15 Day Lookahead' },
        { label: '30 Day Lookahead' },
        { label: '45 Day Lookahead' },
      ],
    }
  ];
*/

@Component({
  selector: 'filter-menu',
  templateUrl: 'filter_menu.html',
})
export class FilterMenuComponent {
  @Input() sections: FilterSections;
  @Output() onDone = new EventEmitter();
  @Output() onCancel = new EventEmitter();
  @Output() onClearFilters = new EventEmitter();

  public isDev = ISDEV;

  constructor() {
  }

  onClickSectionHeader(section) {
    section.isExpanded = !section.isExpanded;
  }

  onValueChange(section, option, newValue) {
    if (newValue === true && section.multiselect === false) {
      section.options.forEach((option) => {
        option.selected = false;
      });
      option.selected = newValue;
    }
  }


  getNumSelected(section) {
    return section.options.reduce((total, option) => {
      return total + (option.selected ? 1 : 0);
    }, 0);
  }

}

@Component({
  template: `
    <ion-header>
      <ion-navbar color="primary">
       <ion-buttons left>
         <button ion-button icon-only (click)="clearFilters()">
              <ion-icon name="refresh"></ion-icon>
          </button>
        </ion-buttons>

        <ion-title>{{title}}</ion-title>

        <ion-buttons end>
           <button ion-button icon-only (click)="onCancel()">
            <ion-icon name="close"></ion-icon>
          </button>
        </ion-buttons>
      </ion-navbar>
    </ion-header>
    <ion-content class="filter-menu">
      <filter-menu [(sections)]="sections"></filter-menu>
    </ion-content>
    <ion-footer padding>
  <button ion-button (click)="onDone()" block margin-bottom>Apply Filters</button>
</ion-footer>
    `
})
export class FilterMenuModal implements OnInit {
  sections: FilterSections;
  title: string;
  activities: Activity[];
  public isDev = ISDEV;

  constructor(
    private _app: App,
    public params: NavParams,
  ) {

  }

  ionViewDidEnter() {
    this._app.setTitle(APP_TITLE);
  }

  ngOnInit(){
    let sections = this.params.get('sections');
    this.activities = this.params.get('activities');
    this.title = this.params.get('title') || 'Filter';
    if(this.activities && this.activities.length){
     if(this.isDev == true) {  console.log("activities.length", this.activities.length) }
      sections = sections.map(filterCode=>{
        if(filterCode.type==="code"){
          filterCode.options=filterCode.options.map(option=> {
            if( !(option.selected || this.activities.find(activity=>{
              return activity.tskActRows.find(row=>{
                return row.actv_code_id===option.value;
              }) ? true : false;
            }) ? true : false)){
              option.notVisible=true;
            } else {
              option.notVisible=false;
            }
            return option
          });
        }

        return filterCode;
      });
    }
    sections = sections.filter(section=>section.options.length)
    this.sections=sections;
  }

  onDone() {
    const cbOnDone = this.params.get('onDone');
    cbOnDone(); //.emit(this.sections);
  }


  clearFilters(){
    this.sections=this.sections.map(section=>{
      section.options=section.options.map(option=>{
        option.selected = false;
        return option;
      })
      return section;
    })
    this.onDone();
  }

  onCancel() {
    const cbOnCancel = this.params.get('onCancel');
    cbOnCancel(); //.emit();
  }


}



// WEBPACK FOOTER //
// ./src/directives/filter_menu/filter_menu.component.ts